import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedUserAction, updateUserAction } from '../../../redux/actions/usersActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import UserUpdateForm from '../forms/UserUpdateForm';

const UpdateUserModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const roles = useSelector((state) => state.roles.roles);
  const user = useSelector((state) => state.users?.user);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(updateUserAction(data));
    await dispatch(clearSelectedUserAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити інформація користувача'}
      loading={loading}
      onClose={onModalClose}
      body={<UserUpdateForm roles={roles} readOnly={readOnly} onSubmit={onSubmit} loading={loading} user={user} />}
      actionButton={
        !readOnly && (
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'user-form'} children={'Змінити'} />
        )
      }
    />
  );
};

export default UpdateUserModal;
